// Import package components
import { useState, useContext, useCallback, useEffect } from "react";
import { Flex } from "uikit-react";
import { useCookies } from "react-cookie";
import moment from "moment";

import FilterPanel from "../Common/FilterPanel";
import usePath from "../Common/History";
import Pagination from "../../common/Pagination";
import { AppContexts } from "../../../providers";
import RecordsPerPage from "../../common/RecordsPerPage";

const GuestBookViewByGuest = () => {
  const { guestbookByGuest, getGuestBooksByGuest, startDate, endDate, active } = useContext(
    AppContexts.ReportsContext
  );

  const [cookies] = useCookies(["records-per-page"]);
  const { "records-per-page": recordsPerPage = 20 } = cookies;

  const [filter, setFilter] = useState("");
  const [page, setPage] = useState(0);

  const { total, paginated } = guestbookByGuest;

  const path = usePath();

  useEffect(() => {
    if (path !== active) {
      setPage(0);
      setFilter("");
    }
  }, [path]);

  useEffect(() => {
    if (active === "guestbook-by-guest") getFn(startDate, endDate);
  }, [page, filter, recordsPerPage]);

  const getFn = useCallback(
    (startDate, endDate) => {
      if (!startDate || !endDate) {
        return;
      } else {
        getGuestBooksByGuest(
          startDate,
          endDate,
          page,
          recordsPerPage,
          filter ? filter.trim() : filter
        );
      }
    },
    [page, filter, recordsPerPage]
  );

  const handlePageChange = useCallback((page) => setPage(page), []);
  const handleFilterChange = useCallback((filter) => setFilter(filter), []);

  return (
    <li className="reports-tab-content">
      <h2>Guestbook Views</h2>
      <div className="uk-card hms-left-tabs-content-card uk-padding-remove">
        <FilterPanel
          searchTermPlaceholder="Guest Name Or Property ID"
          onFilterChange={handleFilterChange}
          onSubmit={getFn}
        />
        <div className="secondary">{total} GuestBook Views</div>
        <table className="uk-table uk-table-hover uk-table-divider hms-table uk-margin-small-top">
          <thead>
            <tr>
              <th>GUEST NAME</th>
              <th>CHECK-IN DATE</th>
              <th>PROPERTY ID</th>
              <th>URL</th>
              <th>COUNT</th>
            </tr>
          </thead>
          <tbody>
            {paginated?.length ? (
              paginated?.map((item) => (
                <tr>
                  <td>
                    {item.first_name} {item.last_name}
                  </td>
                  <td>
                    {moment.utc(item.check_in).format("MM/DD/YYYY")}
                  </td>
                  <td className="reports-table-wrap-overflow">
                    {item.pms_id}
                  </td>
                  <td>
                    <a href={`${item.url}`} target="_blank" rel="noopener noreferrer">
                      {item.url}
                    </a>
                  </td>
                  <td>{item.count}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="no-results">
                  No results for this date range
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Flex alignment="between top" className="guest-form-top-filters">
        <Pagination
          count={total}
          index={page}
          onIndexChanged={handlePageChange}
        />
        {total > 0 && <RecordsPerPage />}
      </Flex>
    </li>
  );
};

export default GuestBookViewByGuest;
